import React, { useEffect } from 'react'
import OutputPanel from './OutputPanel'
import { getOutputPermissions } from './OutputPanel/utilities/actions'

const OutputTab = ({ admin }) => {
  const { roles, output } = admin

  useEffect(() => {
    getOutputPermissions()
  }, [])

  return (
    <div className='role-view'>
      <div className='children-view'>
        <OutputPanel roles={roles} output={output} />
      </div>
    </div>
  )
}

export default OutputTab
